/* Lokal växling: alla format finns redan i HTML. Ingen fetch eller sidnavigering.
   Två flikar (ark, rull) eller tre när bivoksposerna är publicerade (Inkorgen 105). */
(function () {
  'use strict';
  var root = document.querySelector('[data-vk-wax-workspace]');
  if (!root || root.getAttribute('data-vk-wax-ready')) return;
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-vk-wax-tab]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-vk-wax-panel]'));
  if (tabs.length < 2 || tabs.length !== panels.length) return;
  var names = tabs.map(function (tab) { return tab.getAttribute('data-vk-wax-tab'); });
  // En enda 10 %-ruta på sidan (dess skript binder bara en). Den flyttas till den öppna flikens plats.
  var kod = root.querySelector('[data-vk-kodruta]');
  function moveKod(name) {
    var panel = kod && root.querySelector('[data-vk-wax-panel="' + name + '"]');
    var slot = panel && panel.querySelector('[data-vk-kod-slot]');
    if (slot && kod.parentNode !== slot) slot.appendChild(kod);
  }
  function event(name) {
    try { document.dispatchEvent(new CustomEvent(name)); }
    catch (err) { var ev = document.createEvent('Event'); ev.initEvent(name, true, false); document.dispatchEvent(ev); }
  }
  function switchFormat(name, writeHash) {
    if (names.indexOf(name) < 0) return;
    panels.forEach(function (panel) { panel.hidden = panel.getAttribute('data-vk-wax-panel') !== name; });
    tabs.forEach(function (tab) {
      var active = tab.getAttribute('data-vk-wax-tab') === name;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });
    root.setAttribute('data-vk-wax-active', name);
    moveKod(name);
    if (writeHash && window.history && history.replaceState) {
      history.replaceState(history.state, '', location.pathname + location.search + '#vk-wax-' + name);
    }
    event('vk:wax-format');
  }
  root.querySelector('[data-vk-wax-tabs]').setAttribute('role', 'tablist');
  panels.forEach(function (panel) {
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', 'vk-wax-tab-' + panel.getAttribute('data-vk-wax-panel'));
  });
  tabs.forEach(function (tab, index) {
    tab.setAttribute('role', 'tab');
    tab.setAttribute('aria-controls', 'vk-wax-' + tab.getAttribute('data-vk-wax-tab'));
    tab.addEventListener('click', function (e) {
      if (e.button && e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
      e.preventDefault(); switchFormat(tab.getAttribute('data-vk-wax-tab'), true);
    });
    tab.addEventListener('keydown', function (e) {
      var next = index;
      if (e.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      else if (e.key === ' ') { e.preventDefault(); tab.click(); return; }
      else return;
      e.preventDefault(); switchFormat(names[next], true); tabs[next].focus();
    });
  });
  function initialFormat() {
    var hash = location.hash.replace('#vk-wax-', '');
    return names.indexOf(hash) > -1 ? hash : root.getAttribute('data-vk-wax-initial');
  }
  switchFormat(initialFormat(), false);
  root.setAttribute('data-vk-wax-ready', 'true');
  window.addEventListener('hashchange', function () {
    var name = location.hash.replace('#vk-wax-', '');
    if (names.indexOf(name) > -1) switchFormat(name, false);
  });
  ['roll', 'pose'].forEach(function (name) {
    var panel = root.querySelector('[data-vk-wax-panel="' + name + '"]');
    if (panel && !(name === 'pose' && bindPoseSizes(panel))) bindChoices(panel);
  });
  // Bivoksposer i storlekar (Inkorgen 173, 29/10): storlek × mønster ur matrisen i vokshus-pose-panel.
  // Rutorna och mønstren är länkar till rätt variant, så köpet fungerar även utan det här skriptet.
  function bindPoseSizes(panel) {
    var matrixEl = panel.querySelector('[data-vk-pose-matrix]');
    var form = panel.querySelector('form.vk-catalog-product__form');
    if (!matrixEl || !form) return false;
    var matrix;
    try { matrix = JSON.parse(matrixEl.textContent); } catch (err) { return false; }
    var id = form.querySelector('[name="id"]');
    var packing = form.querySelector('[name="properties[_PackingList]"]');
    var buy = form.querySelector('[type="submit"]');
    var price = panel.querySelector('.vk-catalog-product__current');
    var chosen = panel.querySelector('.vk-new-product__chosen');
    var image = panel.querySelector('[data-vk-gallery-main]');
    var buyPrefix = panel.querySelector('[data-vk-roll-buy-label]').getAttribute('data-vk-roll-buy-label');
    var sizes = Array.prototype.slice.call(panel.querySelectorAll('[data-vk-pose-size]'));
    var patterns = Array.prototype.slice.call(panel.querySelectorAll('[data-vk-pose-pattern]'));
    var activeSize = panel.querySelector('[data-vk-pose-size].is-selected');
    var activePattern = panel.querySelector('[data-vk-pose-pattern].is-active');
    var state = {
      size: activeSize ? activeSize.getAttribute('data-vk-pose-size') : 'set',
      pattern: activePattern ? activePattern.getAttribute('data-vk-pose-pattern') : Object.keys(matrix)[0]
    };
    var submitting = false;
    var shownImg = (matrix[state.pattern] && matrix[state.pattern].sizes[state.size] || {}).img;
    function variantUrl(variantId) { return location.pathname + '?variant=' + variantId + '#vk-wax-pose'; }
    function showImage(source, name) {
      if (!source) return;
      var thumbs = panel.querySelectorAll('[data-vk-gallery-thumb]');
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('data-img').split('?')[0] === source.split('?')[0]) { thumbs[i].click(); return; }
      }
      // Bilden finns inte bland miniatyrerna: visa den direkt och avmarkera miniatyrerna, så att ingen fel bild ser vald ut.
      for (var j = 0; j < thumbs.length; j++) { thumbs[j].classList.remove('is-active'); thumbs[j].setAttribute('aria-selected', 'false'); }
      if (image) { image.removeAttribute('srcset'); image.src = source; image.alt = name; }
    }
    function apply() {
      var pat = matrix[state.pattern];
      var v = pat && pat.sizes[state.size];
      if (!v) return;
      id.value = v.id;
      packing.value = v.packing;
      price.textContent = v.money;
      if (chosen) chosen.textContent = pat.name;
      buy.disabled = !v.available;
      if (v.available) buy.textContent = buyPrefix + ' ' + v.money;
      sizes.forEach(function (el) {
        var key = el.getAttribute('data-vk-pose-size'), on = key === state.size, sv = pat.sizes[key];
        el.classList.toggle('is-selected', on);
        if (on) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current');
        if (!sv) return;
        el.href = variantUrl(sv.id);
        el.querySelector('[data-vk-pose-size-money]').textContent = sv.money;
        var save = el.querySelector('[data-vk-pose-save]');
        if (save) { save.textContent = pat.save; save.hidden = !pat.save; }
      });
      patterns.forEach(function (el) {
        var key = el.getAttribute('data-vk-pose-pattern'), on = key === state.pattern, pv = matrix[key];
        el.classList.toggle('is-active', on);
        if (on) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current');
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (pv && pv.sizes[state.size]) { el.href = variantUrl(pv.sizes[state.size].id); el.setAttribute('data-vk-roll-choice', pv.sizes[state.size].id); }
      });
      // Styckpåsarna har en egen bild (en påse), setet 3-påsbilden: byt när variantens bild ändras.
      if (v.img && v.img !== shownImg) { showImage(v.img, pat.name); shownImg = v.img; }
    }
    function onPick(el, field) {
      el.addEventListener('click', function (e) {
        if (e.button && e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        if (submitting) return;
        state[field] = el.getAttribute(field === 'size' ? 'data-vk-pose-size' : 'data-vk-pose-pattern');
        apply();
      });
    }
    sizes.forEach(function (el) { onPick(el, 'size'); });
    patterns.forEach(function (el) { onPick(el, 'pattern'); });
    // Native POST skickas en gång. Återgång via webbläsarens bakåtknapp låser upp igen.
    form.addEventListener('submit', function (e) {
      if (submitting) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      if (e.defaultPrevented) return;
      submitting = true;
      buy.disabled = true;
    });
    window.addEventListener('pageshow', function () { submitting = false; apply(); });
    return true;
  }
  function bindChoices(roll) {
  var form = roll.querySelector('form.vk-catalog-product__form');
  var choices = Array.prototype.slice.call(roll.querySelectorAll('[data-vk-roll-choice]'));
  if (!form || !choices.length) return;
  var id = form.querySelector('[name="id"]');
  var packing = form.querySelector('[name="properties[_PackingList]"]');
  var buy = form.querySelector('[type="submit"]');
  var image = roll.querySelector('[data-vk-gallery-main]');
  var currentPrice = roll.querySelector('.vk-catalog-product__current');
  var currentName = roll.querySelector('.vk-new-product__chosen');
  var buyPrefix = roll.querySelector('[data-vk-roll-buy-label]').getAttribute('data-vk-roll-buy-label');
  // Radiofälten är själva native-formulärets antal och fungerar utan detta skript.
  var offer = form.querySelector('[data-vk-roll-offer]');
  var offerPrices = null, submitting = false;
  // Posernas antal (1 / 2 / 3 sett): radiofälten är formulärets antal, här följer bara priserna med.
  var qtyOffer = form.querySelector('[data-vk-qty-offer]'), qtyPrices = null;
  if (qtyOffer) {
    try { qtyPrices = JSON.parse(qtyOffer.querySelector('[data-vk-qty-prices]').textContent); }
    catch (err) { qtyPrices = null; }
    Array.prototype.forEach.call(qtyOffer.querySelectorAll('input[name="quantity"]'), function (input) {
      input.addEventListener('change', refreshQty);
    });
  }
  function refreshQty() {
    if (!qtyOffer || !qtyPrices || !qtyPrices[id.value]) return;
    var prices = qtyPrices[id.value];
    var checked = qtyOffer.querySelector('input[name="quantity"]:checked');
    Array.prototype.forEach.call(qtyOffer.querySelectorAll('[data-vk-qty-money]'), function (el) {
      el.textContent = prices[el.getAttribute('data-vk-qty-money')];
    });
    Array.prototype.forEach.call(qtyOffer.querySelectorAll('input[name="quantity"]'), function (input) {
      input.parentNode.classList.toggle('is-selected', input.checked);
    });
    if (!buy.disabled) buy.textContent = buyPrefix + ' ' + prices[checked ? checked.value : '1'];
  }
  if (offer) {
    try { offerPrices = JSON.parse(offer.querySelector('[data-vk-offer-prices]').textContent); }
    catch (err) { offerPrices = null; }
    Array.prototype.forEach.call(offer.querySelectorAll('input[name="quantity"]'), function (input) {
      input.addEventListener('change', refreshOffer);
    });
  }
  function refreshOffer() {
    if (!offer || !offerPrices || !offerPrices[id.value]) return;
    var prices = offerPrices[id.value];
    var selectedQuantity = offer.querySelector('input[name="quantity"]:checked');
    var size = selectedQuantity ? selectedQuantity.value : '1';
    Array.prototype.forEach.call(offer.querySelectorAll('[data-vk-offer-money]'), function (el) {
      el.textContent = prices[el.getAttribute('data-vk-offer-money')];
    });
    offer.querySelector('[data-vk-offer-pattern]').textContent = prices.name;
    Array.prototype.forEach.call(offer.querySelectorAll('input[name="quantity"]'), function (input) {
      input.parentNode.classList.toggle('is-selected', input.checked);
    });
    offer.querySelector('[data-vk-offer-summary]').hidden = size !== '3';
    offer.setAttribute('data-vk-offer-size', size);
    buy.textContent = buyPrefix + ' ' + (size === '3' ? prices.triple : prices.single);
  }
  // Native POST skickas en gång. Återgång via webbläsarens bakåtknapp låser upp igen.
  form.addEventListener('submit', function (e) {
    if (submitting) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (e.defaultPrevented) return;
    submitting = true;
    buy.disabled = true;
  });
  window.addEventListener('pageshow', function () {
    submitting = false;
    var selectedChoice = choices.filter(function (choice) { return choice.getAttribute('data-vk-roll-choice') === id.value; })[0];
    buy.disabled = !selectedChoice || selectedChoice.getAttribute('data-available') !== 'true';
    refreshOffer();
    refreshQty();
  });
  refreshOffer();
  refreshQty();
  choices.forEach(function (choice) {
    choice.setAttribute('role', 'button');
    choice.addEventListener('keydown', function (e) { if (e.key === ' ') { e.preventDefault(); choice.click(); } });
    choice.addEventListener('click', function (e) {
      if (e.button && e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      if (submitting || choice.getAttribute('data-available') !== 'true') return;
      id.value = choice.getAttribute('data-vk-roll-choice');
      packing.value = choice.getAttribute('data-packing');
      var price = choice.getAttribute('data-money');
      currentPrice.textContent = price;
      if (currentName) currentName.textContent = choice.getAttribute('data-name');
      buy.textContent = offer ? buyPrefix : buyPrefix + ' ' + price; buy.disabled = false;
      refreshOffer();
      refreshQty();
      choices.forEach(function (other) {
        var on = other === choice;
        other.classList.toggle('is-active', on); other.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) other.setAttribute('aria-current', 'true'); else other.removeAttribute('aria-current');
      });
      var source = choice.getAttribute('data-img');
      var galleryThumbs = roll.querySelectorAll('[data-vk-gallery-thumb]');
      var matchingThumb = null;
      for (var i = 0; i < galleryThumbs.length; i++) {
        if (galleryThumbs[i].getAttribute('data-img').split('?')[0] === source.split('?')[0]) matchingThumb = galleryThumbs[i];
      }
      if (matchingThumb) matchingThumb.click();
      else if (image && source) { image.removeAttribute('srcset'); image.src = source; image.alt = choice.getAttribute('data-name'); }
    });
    choice.setAttribute('aria-pressed', choice.classList.contains('is-active') ? 'true' : 'false');
    if (choice.getAttribute('data-available') !== 'true') choice.setAttribute('aria-disabled', 'true');
  });
  }
})();
